import { safetyTips } from '@/mocks/downloadData';

export default function Safety() {
  return (
    <section id="safety" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
            <i className="ri-shield-check-line"></i>
            SAFETY
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            使用提示与安全说明
          </h2>
          <p className="mt-3 max-w-2xl text-foreground-600 text-sm md:text-base leading-relaxed">
            访问网络服务时，养成几个简单的习惯就能避开大部分风险。下面几点建议供参考。
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {safetyTips.map((tip) => (
            <div key={tip.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-xl">
                <i className={tip.icon}></i>
              </span>
              <h3 className="mt-4 text-foreground-950 text-base font-medium">{tip.title}</h3>
              <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{tip.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}